import { print } from "graphql";
import { BaseAPI } from "@/api/base.api";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { map } from "rxjs/operators";
import { Localidade } from "@/models/localidade";
import { VUE_APP_SIT_API_URL } from '@/commons/config';

const localidade = require("@/query/linhas-regulares/Localidade.graphql");

export class LocalidadeAPI extends BaseAPI<Localidade> {
  constructor() {
    super();
    this.apiUrl = `${this.apiUrl}/linhas-regulares`;
  }

  public getAll(): AxiosObservable<Localidade[]> {
    return this.axios
      .post(`${this.graphqlUrl}`, {
        query: print(localidade),
        variables: {}
      })
      .pipe(
        map((data: any) => {
          const { localidades } = data;

          return localidades.map(
            (localidade: any) =>
              new Localidade(
                localidade.id,
                localidade.nome,
                localidade.municipio
              )
          );
        })
      );
  }

  public findAll (): AxiosObservable<Localidade[]> {
    return this.axios.post(`${VUE_APP_SIT_API_URL}/autorizacoesFretamento/localidades`,{})
  }
}
